import React from "react";

export const Terms = () => {
  return (
    <div className="footerComponentText">
      <h1>Terms and Conditions of Purchase (general)</h1>
      <hr />
      <br />
      <h3>1.- GENERAL CONDITIONS OF SALE:</h3>
      <p>
        The Registration as a Client and application for a Purchase Request,
        expresses the acceptance of all the terms indicated within the General
        Conditions established in this agreement. The Client confirms having
        read, understood and accepted them in full remaining to the effect bound
        by them.
      </p>
      <br />
      <h3>2.- CUSTOMER REGISTRATION, PURCHASES:</h3>
      <p>
        The Purchase will be considered as Registered and Applicable when the
        Client SATISFACTORILY completes each and every one of the spaces,
        especially those marked as mandatory. The Client will provide personal
        information in an exact, precise and true manner and assumes the
        commitment to update their Personal Data as necessary; however, CINEMA
        TIME is not responsible for the accuracy of the data provided by the
        Client. The Client is responsible for the personal information provided,
        as well as its veracity, accuracy and validity. Once the Purchase is
        registered, CINEMA TIME through its website will immediately send an
        e-mail confirming the processing of the order.
      </p>
      <br />
      <h3>3.-WEB PAGE:</h3>
      <p>
        It is a document placed on a server so that it is available on the
        Internet that contains information, which can be navigated through
        “links” to other places on the same page or to other pages: The pages
        are hypertext documents, this means that, in addition to text, they
        contain sound and images that can be related to each other.
      </p>
      <br />
      <h3>4.- THE PRICE OF THE PRODUCT:</h3>
      <p>
        It is the amount indicated on THIS SITE for each ticket, plus the
        corresponding Value Added Tax (VAT): The unit price will be charged in
        Pesos (legal currency of Argentinian).
      </p>
      <br />
      <h3>5.-TERMS OF PURCHASE on the Web (published):</h3>
      <p>
        • CINEMA TIME undertakes to make every effort to make THIS PORTAL
        available to all users seven (7) days a week, twenty-four (24) hours a
        day. However, the user accepts that the service may have faults and may
        be interrupted by faults outside of CINEMA TIME. •The services are
        exclusively for personal use and in no way may be for commercial use or
        of any other type: The services may not be used to sell or promote a
        third party service or product. • If there is a selection of seats for
        the function purchased, those reflected in the system and in the
        purchase order will be taken as valid locations.. • In theaters that do
        not have the option of numbered seats, the location of adjoining seats
        is not guaranteed: The client must take their forecasts when picking up
        their tickets or tickets. • The functions for sale will be available
        until the day of the function and up to one (1) hour before its start or
        until the quotas assigned to the capacity of the theater are covered. In
        case of purchases for the following days - Future sales • CINEMA TIME
        will notify the client in the event that the purchase made is not
        screened for reasons beyond our control, in which case the client will
        be relocated in mutual agreement with the client.. • When picking up
        their tickets, the customer must: - Have your credit card and laminated
        identity card physically. Under no circumstances will tickets be
        delivered without the presence of the credit card holder, the locator
        number and the laminated identity card. - Have your credit card
        physically. Under no circumstances will the tickets be delivered if the
        physical Credit Card is not in possession. Otherwise, the validity of
        the tickets will be void and they cannot be reused. - Insert your credit
        card in the automatic ticket dispensers (ATM). If there is no ATM, you
        must present it at the cinema box office. - If there is any problem when
        withdrawing the tickets through the ATM, the client must go to the box
        office and present their physical credit card, their identity card and
        the number of their purchase confirmation so that they can be delivered
        there. • The promotions and prices of the functions of each circuit will
        be subject to change and these will be reflected in the purchase. The
        application of a promotion is at the customer's free choice, so it is
        their responsibility that the system applies these. • For security and
        fraud control reasons, the following rules were placed to restrict the
        sale of tickets: - Customers will only be allowed to buy up to Ten (10)
        maximum tickets per transaction. - Customers will only be allowed to
        make one credit card transaction per day. - Only up to three (3) failed
        attempts per purchase (rejections) will be allowed, so the following
        attempts cannot be processed. - If there is any unusual behavior in the
        purchase process, the customer will be contacted and their data
        verified. In the most extreme cases the user will be suspended from the
        system. For more information call 200-CINEMA (246362) or send a message
        from: Contact us or email: info@CINEMATIME.com.ar
      </p>
      <br />
      <h3>6. RESPONSIBILITY:</h3>
      <p>
        CINEMA TIME will be released from the fulfillment of its obligations in
        the purchase made by the client in the following cases: a) Error in
        payment or failure to make it at the time of purchase. Validated by our
        system through a transaction number that is unique and unrepeatable. b)
        Omission or inaccuracy of the information provided by the Client at the
        time of making the purchase. c) Any related to the improper use of the
        Credit Card by a third party, not the owner of the same.
      </p>
      <br />
      <h3>7. RETURNS:</h3>
      <p>
        {" "}
        CINEMA TIME will only be responsible for those purchases that are
        reflected in the application with a valid transaction number and that is
        unknown to the user, in which case the client must channel their claim
        through 200-CINE or through the address . info@CINEMATIME.com.ar
        explained the details of the problem. In the event of multiple charges
        being presented in the payment method used and not being reflected in
        the CINEMA TIME sales system with a valid transaction number, the
        customer must go to the bank that issued their credit card and be
        unaware of the or the consumptions that it does not recognize as valid
        purchases. CINEMA TIME will only be responsible for returning the money
        in the event that the service cannot be provided, due to operational
        failures attributable to the company.
      </p>
      <br />
      <h3>8. FAILURES IN THE SYSTEM:</h3>
      <p>
        CINEMA TIME does not guarantee the continuous entry and uninterrupted
        use of its website, because the system is supported and is supported by
        elements in which CINEMA TIME is not and will not be responsible for
        failures that occur in the hardware, software and Internet of its
        clients and consequently it is not and will not be responsible for any
        damage, loss or loss to the Client caused by these failures in the
        system, in the server or in the Internet. CINEMA TIME will also not be
        responsible for any virus that could infect the client's equipment as a
        result of access, use or examination of its website or as a result of
        any transfer of data, files, images, videos or texts. The system may
        eventually be unavailable due to technical difficulties or Internet
        failures, or for any other circumstance beyond the control of CINEMA
        TIME; in such cases, efforts will be made to restore it as quickly as
        possible without, therefore, imputing any type of responsibility due to
        the damages resulting from technical difficulties or failures in the
        systems or on the Internet.
      </p>

      <h1>
        PRIVACY, CONFIDENTIALITY AND SECURITY OF CUSTOMER REGISTRATION (PERSONAL
        DATA)
      </h1>
      <hr />
      <br />
      <h3>9. CONFIDENTIALITY:</h3>
      <p>
        CINEMA TIME guarantees the privacy, protection and confidentiality of
        personal, home, payment and any other data provided by our clients,
        ensuring that they are not transferred for another use without obtaining
        the prior and express consent of our clients. Each of the parties
        undertakes to maintain the most complete and absolute confidentiality
        regarding any oral, written, graphic, electromagnetic information and
        documentation, data, technical and commercial specifications, related to
        the structure, operations, actions, which they may reach. have knowledge
        or access in connection with this agreement; and, unless authorized in
        writing by the other party, or when the information is required by any
        competent authority, in accordance with the laws in force in the
        country; will refrain from disclosing, revealing or making known to
        third parties outside this contractual relationship, any type of
        information regarding the other party. When registering at CINEMA TIME
        and/or CINEMA TIME.COM, the client's information will automatically be
        stored in the database of both pages. CINEMA TIME customers can, at any
        time, exercise their access rights, updating and/or modifying their
        personal account, in addition to canceling it by sending an email to
        this email address www.CINEMA TIME.com.ve. When registering on our
        CINEMA TIME page, the client also accepts their entry to a basic list
        where they will receive information regarding new releases, promotions
        and any other, via email or through the text messaging service (SMS); if
        the Client wishes, they can be removed from the list by sending an email
        to www.CINEMA TIME.com.ve and write "Withdraw" in the Subject of the
        email. In the event that THE CUSTOMER indicates that they do not wish to
        receive the information, CINEMA TIME must remove it from its basic list
        of recipients within 24 hours. CINEMA TIME's Terms and Conditions may be
        updated or modified with or without prior notice, so CINEMA TIME may
        terminate or revise any aspect of the service at its sole discretion and
        without prior notice. At any time the CLIENT may review the most recent
        version of the Terms and Conditions in CINEMA TIME. For more information
        call 200-CINEMA (246362) or send a message from: Contact us or email:
        info@CINEMATIME.com.ar Any person who does not accept these general
        terms and conditions, which are mandatory and binding, must refrain from
        using the site and/or the services. The Client will be responsible for
        all the operations carried out in his account, since access to it is
        restricted to the entry and use of his "User Name" and "Access Code", of
        exclusive knowledge of the Client. The Client undertakes to notify
        CINEMA TIME immediately and by reliable means, of any unauthorized use
        of his account, as well as the entry by unauthorized third parties to
        it.
      </p>
      <br />
      <h3>10. System or Database Violations.</h3>
      <p>
        Any action or use of a device, software, or other means tending to
        interfere with the activities and operations of CINEMA TIME as well as
        with the offers, descriptions, accounts or databases of CINEMA TIME is
        not permitted. Any interference, attempt or activity that violates or is
        contrary to the laws on intellectual property rights and/or the
        prohibitions stipulated in this contract will make the person
        responsible liable for the pertinent legal actions, as well as
        responsible for compensating the damages caused.
      </p>
      <br />
      <h3>11. Intellectual property. Links.</h3>
      <p>
        The contents of ALL the screens related to the products and services
        offered by CINEMA TIME as well as the programs, databases, networks,
        files that allow the client to access and use their account, are the
        property of CINEMA TIME and are protected by law. and international
        treaties on copyright, trademarks, patents, models and industrial
        designs. The improper use and total or partial reproduction of said
        content are prohibited, unless expressly authorized in writing by CINEMA
        TIME. CINEMA TIME may contain on its website links to other websites
        which does not indicate that they are owned or operated by CINEMA TIME.
        Since CINEMA TIME has no control over such sites, it will NOT be
        responsible for the content, materials, actions and/or services provided
        by them, nor for damages or losses caused by their use, whether caused
        directly or indirectly. The presence of links to other websites does not
        imply a partnership, relationship, approval, endorsement by CINEMA TIME
        of said sites and their contents.
      </p>
      <br />
      <h3>12. Causes of force majeure:</h3>
      <p>
        It is understood that in the event that CINEMA TIME ceased its
        commercial functions due to a fortuitous event, force majeure or an act
        of the prince (an act emanating from the State), this agreement will be
        terminated both in fact and in law, without such termination generate
        any compensation for any of the contracting parties.
      </p>
      <br />
      <h3>13. Jurisdiction and Applicable Law.</h3>
      <p>
        This agreement will be governed in all its points by the laws in force
        in Argentina. Any dispute arising from this agreement, its existence,
        validity, interpretation, scope or compliance, will be submitted to the
        applicable laws and to the competent Courts of Argentina and the
        procedures will be carried out in Spanish.
      </p>
      <br />
      <h3>14.INFORMATION AND RULES TO ENJOY THE CINEMA TIME 4DX</h3>

      <p>
        It is of the utmost importance that you follow the rules carefully. The
        4DX movie experience includes seat movements, vibration, rushing air,
        water spray, smells, bright lights, and other special effects. Please
        keep your valuables, including electronic devices, safe. We are not
        responsible for objects that are not properly protected. Entry will only
        be allowed with duly covered soft drinks and popcorn. The entry of hot
        food such as: Tequeños, Hot Dogs, etc. will not be allowed. The effects
        of water, although produced with purified water, can cause deterioration
        in fine or delicate clothing. We are not responsible for any damage.
        Only one person is allowed to occupy a 4DX seat. Exclusively to
        guarantee the safety and safeguard of the health of the users, without
        implying any type of discrimination, it is highly recommended that the
        following people do not enter the 4DX room:? • People less than 1 meter
        tall. • Children under 4 years of age. • Children under 7 years of age
        without the company of their parent or representative. • Pregnant women.
        • Anyone with heart, back, neck problems, vertigo sufferers or any
        condition that may be aggravated by motion, lights or any other aspect
        of the 4DX experience. • Anyone who suffers from epilepsy or any
        significant physical or mental impairment. • We invite all customers who
        do not meet the above points, to enjoy any other feature available on
        our billboard. For more information call 200-CINEMA (246362) or send a
        message from: Contact us or email: info@CINEMATIME.com.ar
      </p>
    </div>
  );
};
